import React from "react";
import { TextField, Typography, Box } from "@mui/material";

export default function NCRTextField({
    name,
    value,
    onChange,
    disabled,
    placeholder = "Enter text",
    error,
    maxLength,
    size = "small",
    sx = { width: "200px" },
    ...restProps
}) {
    const isLimitExceeded = value?.length > maxLength;

    const preventInvalidSpaces = (e) => {
        const { value, selectionStart } = e.target;

        if (e.key === " " && selectionStart === 0) {
            e.preventDefault();
            return;
        }

        if (e.key === " " && value[selectionStart - 1] === " ") {
            e.preventDefault();
        }
    };
    const sanitizeOnInput = (e) => {
        const cleaned = e.target.value
            .replace(/\s{2,}/g, " ")
            .replace(/^\s+/g, "")
            .replace(/\s+$/g, "");

        if (e.target.value !== cleaned) {
            e.target.value = cleaned;
            e.target.dispatchEvent(new Event("input", { bubbles: true }));
        }
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <TextField
                placeholder={placeholder}
                name={name}
                onChange={onChange}
                value={value || ""}
                disabled={disabled}
                error={error || isLimitExceeded}
                size={size}
                sx={sx}
                inputProps={{
                    onKeyDown: preventInvalidSpaces,
                    onBlur: sanitizeOnInput,
                }}
                {...restProps}
            />
            {!disabled && isLimitExceeded && (
                <Typography
                    sx={{
                        fontSize: "11px",
                        color: "#d32f2f",
                        ml: 0,
                        mt: -0.5
                    }}
                >
                    Allowed only max {maxLength} characters
                </Typography>
            )}
        </Box>
    );
}
